// extracted by mini-css-extract-plugin
export var active = "_kj-2";
export var recordingDot = "_kj-1";
export var recordingIndicator = "_kj-0";